'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var qs = require('query-string');

const cleanObject = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object')
            return cleanObject(obj[key]);
        if (obj[key] === undefined) {
            delete obj[key];
            return;
        }
        if (typeof obj[key] === 'string' && !obj[key].length) {
            delete obj[key];
            return;
        }
    });
    return obj;
};

/**
 *
 */
class Querier {
    constructor(options) {
        this.encode = false;
        this.stringify = true;
        this.body = false;
        this.$select = [];
        this.$conditions = {};
        this.$sort = [];
        this.$populate = [];
        if (options === null || options === void 0 ? void 0 : options.body)
            this.body = options.body;
        if (options === null || options === void 0 ? void 0 : options.baseUrl)
            this.baseUrl = options.baseUrl;
        if (options === null || options === void 0 ? void 0 : options.encode)
            this.encode = options.encode;
        if (options === null || options === void 0 ? void 0 : options.resultsPerPage)
            this.$limit = options.resultsPerPage;
        if ((options === null || options === void 0 ? void 0 : options.stringify) === false)
            this.stringify = options.stringify;
    }
    /**
     *
     * @param input
     */
    select(input) {
        this.$select = this.$select.filter(x => x !== `-${input}`);
        if (!this.$select.includes(input))
            this.$select.push(input);
        return this;
    }
    /**
     *
     * @param input
     */
    unselect(input) {
        this.$select = this.$select.filter(x => x !== input);
        this.$select.push(`-${input}`);
        return this;
    }
    /**
     *
     * @param input
     */
    rawConditions(input) {
        if (Object.keys(this.$conditions).length)
            throw new Error(`Conditions are already declared!`);
        this.$conditions = input;
        return this;
    }
    /**
     *
     * @param input
     */
    page(input) {
        this.$limit = this.$limit || 10;
        this.$skip = (input - 1) * this.$limit;
        return this;
    }
    /**
     *
     * @param input
     */
    limit(input) {
        this.$limit = input;
        return this;
    }
    /**
     *
     * @param input
     */
    skip(input) {
        this.$skip = input;
        return this;
    }
    /**
     *
     * @param input
     */
    sort(input) {
        this.$sort.push(input);
        return this;
    }
    /**
     *
     * @param input
     */
    sortDesc(input) {
        this.$sort.push(`-${input}`);
        return this;
    }
    /**
     *
     * @param input
     */
    populate(input) {
        this.$populate.push(input);
        return this;
    }
    /**
     *
     */
    generate() {
        const $select = this.cleanSelect();
        const $conditions = this.cleanConditions();
        const $skip = this.cleanSkip();
        const $limit = this.cleanLimit();
        const $sort = this.cleanSort();
        const $populate = this.cleanPopulate();
        const result = cleanObject({
            $select,
            $skip,
            $limit,
            $sort,
            $populate
        });
        if ($conditions)
            result.$conditions = $conditions;
        return this.stringify && !this.body ? this.generateString(result) : result;
    }
    /**
     *
     */
    generateString(query) {
        query = Object.keys(query).reduce((result, key) => {
            const value = query[key];
            const type = typeof value;
            result[key] = type === 'object' ? JSON.stringify(value) : value;
            return result;
        }, {});
        if (!Object.keys(query).length)
            return this.baseUrl || '';
        const stringified = qs.stringify(query, { encode: this.encode });
        return `${this.baseUrl || ''}?${stringified}`;
    }
    /**
     *
     */
    cleanPopulate() {
        return this.$populate.length ? this.$populate.join(' ') : undefined;
    }
    /**
     *
     */
    cleanSelect() {
        return this.$select.length ? this.$select.join(' ') : undefined;
    }
    /**
     *
     */
    cleanSkip() {
        return this.$skip;
    }
    /**
     *
     */
    cleanSort() {
        return this.$sort.length ? this.$sort.join(' ') : undefined;
    }
    /**
     *
     */
    cleanLimit() {
        return this.$limit;
    }
    /**
     *
     */
    cleanConditions() {
        return Object.keys(this.$conditions).length ? this.$conditions : undefined;
    }
    /**
     *
     * @param options
     */
    static query(options) {
        return new Querier(options);
    }
    /**
     *
     */
    static bodyQuery(options) {
        options.body = true;
        options.stringify = false;
        options.encode = false;
        return new Querier(options);
    }
}

exports.Querier = Querier;
//# sourceMappingURL=querier.js.map
